module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-03-bd62b8f6b2e057b5fae21e4034cbd263.svg";